// extracted by mini-css-extract-plugin
export default {"creation":"creation_lvKR4","img":"img_QsGde","rule":"rule_a2wLi","titleInput":"titleInput_PwOex","cover":"cover_ZyYKj","coverBox":"coverBox_K86Ec"};